// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
export var AddSecretKernelAttachmentRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteSecretKernelAttachmentRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteUserSecretRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteUserSecretResponse = {
    wasAttached: false,
    secretId: 0
};
export var DeleteUserSecretResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteUserSecretResponse, wireFormat);
        return message;
    }
};
export var ExchangeGcloudAuthorizationCodeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetGitHubAccessInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetGitHubAccessInfoResponse = {
    secretId: 0
};
export var GetGitHubAccessInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetGitHubAccessInfoResponse, wireFormat);
        return message;
    }
};
export var GetUserSecretByLabelRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserSecretResponse = {
    secretId: 0,
    expiresInSeconds: 0
};
export var GetUserSecretResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserSecretResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.expiresInSeconds) {
            message.expiresInSeconds = parseInt(wireFormat.expiresInSeconds);
        }
        if (wireFormat) {
            message.secretType = UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
        }
        if (wireFormat) {
            message.secretProvider = UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
        }
        return message;
    }
};
export var ListKernelSecretsMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelSecretsMetadataResponse = {
    kernelSecretsMetadata: []
};
export var ListKernelSecretsMetadataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelSecretsMetadataResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelSecretsMetadata) {
            message.kernelSecretsMetadata = wireFormat.kernelSecretsMetadata.map(function(i) {
                return UserSecretKernelAttachmentMetadataWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListKernelsWithSecretRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelsWithSecretResponse = {
    kernelsWithSecret: []
};
export var ListKernelsWithSecretResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelsWithSecretResponse, wireFormat);
        return message;
    }
};
export var ListUserSecretsMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.target) {
            wireFormat.target = UserSecretTargetTypeWireFormat3.toJson(message.target);
        }
        if (message === null || message === void 0 ? void 0 : message.provider) {
            wireFormat.provider = UserSecretProviderTypeWireFormat3.toJson(message.provider);
        }
        return wireFormat;
    }
};
var defaultListUserSecretsMetadataResponse = {
    userSecretsMetadata: []
};
export var ListUserSecretsMetadataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListUserSecretsMetadataResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userSecretsMetadata) {
            message.userSecretsMetadata = wireFormat.userSecretsMetadata.map(function(i) {
                return UserSecretMetadataWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpsertCustomUserSecretRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUserSecretKernelAttachmentMetadata = {
    attachmentId: 0,
    secretId: 0,
    secretTargets: []
};
export var UserSecretKernelAttachmentMetadataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserSecretKernelAttachmentMetadata, wireFormat);
        if (wireFormat) {
            message.secretType = UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
        }
        if (wireFormat) {
            message.secretProvider = UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.secretTargets) {
            message.secretTargets = wireFormat.secretTargets.map(function(i) {
                return UserSecretTargetTypeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultUserSecretMetadata = {
    secretId: 0,
    secretTargets: []
};
export var UserSecretMetadataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserSecretMetadata, wireFormat);
        if (wireFormat) {
            message.secretType = UserSecretTypeWireFormat3.fromJson(wireFormat.secretType);
        }
        if (wireFormat) {
            message.secretProvider = UserSecretProviderTypeWireFormat3.fromJson(wireFormat.secretProvider);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.secretTargets) {
            message.secretTargets = wireFormat.secretTargets.map(function(i) {
                return UserSecretTargetTypeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UserSecretProviderType;
(function(UserSecretProviderType) {
    UserSecretProviderType["UNSPECIFIED"] = "unspecified";
    UserSecretProviderType["GOOGLE"] = "google";
    UserSecretProviderType["USER"] = "user";
    UserSecretProviderType["GITHUB"] = "github";
})(UserSecretProviderType || (UserSecretProviderType = {}));
export var UserSecretProviderTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "USER_SECRET_PROVIDER_TYPE_UNSPECIFIED":
            default:
                return UserSecretProviderType.UNSPECIFIED;
            case "GOOGLE":
                return UserSecretProviderType.GOOGLE;
            case "USER":
                return UserSecretProviderType.USER;
            case "GITHUB":
                return UserSecretProviderType.GITHUB;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UserSecretProviderType.UNSPECIFIED:
            case 0:
            default:
                return "USER_SECRET_PROVIDER_TYPE_UNSPECIFIED";
            case UserSecretProviderType.GOOGLE:
            case 1:
                return "GOOGLE";
            case UserSecretProviderType.USER:
            case 2:
                return "USER";
            case UserSecretProviderType.GITHUB:
            case 3:
                return "GITHUB";
        }
    }
};
export var UserSecretTargetType;
(function(UserSecretTargetType) {
    UserSecretTargetType["UNSPECIFIED"] = "unspecified";
    UserSecretTargetType["BIGQUERY"] = "bigquery";
    UserSecretTargetType["GCS"] = "gcs";
    UserSecretTargetType["CLOUD_AI"] = "cloudAi";
    UserSecretTargetType[// Left AutoMl temporarily for transition (in this order)
    "AUTO_ML"] = "autoMl";
})(UserSecretTargetType || (UserSecretTargetType = {}));
export var UserSecretTargetTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "USER_SECRET_TARGET_TYPE_UNSPECIFIED":
            default:
                return UserSecretTargetType.UNSPECIFIED;
            case "BIGQUERY":
                return UserSecretTargetType.BIGQUERY;
            case "GCS":
                return UserSecretTargetType.GCS;
            case "CLOUD_AI":
                return UserSecretTargetType.CLOUD_AI;
            case "AUTO_ML":
                return UserSecretTargetType.AUTO_ML;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UserSecretTargetType.UNSPECIFIED:
            case 0:
            default:
                return "USER_SECRET_TARGET_TYPE_UNSPECIFIED";
            case UserSecretTargetType.BIGQUERY:
            case 1:
                return "BIGQUERY";
            case UserSecretTargetType.GCS:
            case 2:
                return "GCS";
            case UserSecretTargetType.CLOUD_AI:
            case 3:
                return "CLOUD_AI";
            case UserSecretTargetType.AUTO_ML:
            case 4:
                return "AUTO_ML";
        }
    }
};
export var UserSecretType;
(function(UserSecretType) {
    UserSecretType["UNSPECIFIED"] = "unspecified";
    UserSecretType["REFRESH_TOKEN"] = "refreshToken";
    UserSecretType["CUSTOM"] = "custom";
    UserSecretType["ACCESS_TOKEN"] = "accessToken";
})(UserSecretType || (UserSecretType = {}));
export var UserSecretTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "USER_SECRET_TYPE_UNSPECIFIED":
            default:
                return UserSecretType.UNSPECIFIED;
            case "REFRESH_TOKEN":
                return UserSecretType.REFRESH_TOKEN;
            case "CUSTOM":
                return UserSecretType.CUSTOM;
            case "ACCESS_TOKEN":
                return UserSecretType.ACCESS_TOKEN;
        }
    }
};
export var userSecretsClient = {
    userSecretsService: {
        addSecretKernelAttachment: createClient(AddSecretKernelAttachmentRequestWireFormat3, UserSecretKernelAttachmentMetadataWireFormat3, "user_secrets.UserSecretsService/AddSecretKernelAttachment"),
        deleteSecretKernelAttachment: createClient(DeleteSecretKernelAttachmentRequestWireFormat3, google.protobuf.EmptyWireFormat3, "user_secrets.UserSecretsService/DeleteSecretKernelAttachment"),
        deleteUserSecret: createClient(DeleteUserSecretRequestWireFormat3, DeleteUserSecretResponseWireFormat3, "user_secrets.UserSecretsService/DeleteUserSecret"),
        exchangeGcloudAuthorizationCode: createClient(ExchangeGcloudAuthorizationCodeRequestWireFormat3, UserSecretMetadataWireFormat3, "user_secrets.UserSecretsService/ExchangeGcloudAuthorizationCode"),
        getGitHubAccessInfo: createClient(GetGitHubAccessInfoRequestWireFormat3, GetGitHubAccessInfoResponseWireFormat3, "user_secrets.UserSecretsService/GetGitHubAccessInfo"),
        getUserSecretByLabel: createClient(GetUserSecretByLabelRequestWireFormat3, GetUserSecretResponseWireFormat3, "user_secrets.UserSecretsService/GetUserSecretByLabel"),
        listKernelSecretsMetadata: createClient(ListKernelSecretsMetadataRequestWireFormat3, ListKernelSecretsMetadataResponseWireFormat3, "user_secrets.UserSecretsService/ListKernelSecretsMetadata"),
        listKernelsWithSecret: createClient(ListKernelsWithSecretRequestWireFormat3, ListKernelsWithSecretResponseWireFormat3, "user_secrets.UserSecretsService/ListKernelsWithSecret"),
        listUserSecretsMetadata: createClient(ListUserSecretsMetadataRequestWireFormat3, ListUserSecretsMetadataResponseWireFormat3, "user_secrets.UserSecretsService/ListUserSecretsMetadata"),
        upsertCustomUserSecret: createClient(UpsertCustomUserSecretRequestWireFormat3, UserSecretMetadataWireFormat3, "user_secrets.UserSecretsService/UpsertCustomUserSecret")
    }
};
